import React from 'react';
import RadioButtonGroup from 'material-ui/RadioButton/RadioButtonGroup';
import RadioButton from 'material-ui/RadioButton';
import {PropsObjectType} from "core/form/form";
import {LovItem} from "core/metamodel/mdEntity";
import {lovValue} from "core/form/formUtils";
import {red500} from "material-ui/styles/colors";
import isFunction = require("lodash/isFunction");

interface RadioButtonFieldProps extends PropsObjectType {
  disabled?: boolean|Function;
  optionStyle?: any;
  groupStyle?: any;
  iconStyle?: any;
  iconStyleFn?: (value) => any;
}


/**
 * Requirement is to show number formated if unfocused and unformated if focused,
 * that is to format number on onBlur and deformat on onFocus.
 * props's onChange is called with value parsed into number if possible, or string if not a number
 * Component must have a valueStr to keep a precise entered string and valueNum to distinguish change coming out of the outside
 * These cannot be on state because setState in onChange is not seen in subsequent componentWillReceiveProps
 * But there is additional state's valueStr set in onChange to cause a rerender
 */
//@observer
export default class RadioButtonField extends React.PureComponent<RadioButtonFieldProps, undefined> {

  onChangeInner = (evt) => {
    let lov = this.props.options.find((v) => v.value == evt.target.value);
    this.props.onChange(lov);
  };


  render() {

    let {
      name,
      value,
      labelStyle,
      inputStyle,
      options,
      onChange,
      optionStyle,
      groupStyle,
      iconStyle,
      iconStyleFn,
      style,
      errorText,
      disabled,
      ...other
    } = this.props;


    return (
      <div style={style}>
        <RadioButtonGroup name={name} valueSelected={lovValue(value)} onChange={this.onChangeInner} style={groupStyle}>
          {options.map((lov, index) => <RadioButton key={index} value={lov.value} label={lov.label}
                                                    labelStyle={labelStyle} iconStyle={(iconStyleFn) ? iconStyleFn(lov.value) : iconStyle}
                                                    inputStyle={inputStyle} style={optionStyle} disabled={(isFunction(disabled)) ? disabled(lov) : disabled} />)}
        </RadioButtonGroup>
        <div style={{fontSize:12, color: red500}}>{errorText}</div>
      </div>

    );
  }


}






// WEBPACK FOOTER //
// ./src/core/components/fields/radioButtonField.tsx